import React from 'react';
import { Typography, Box } from '@mui/material';
import { TransactionForm } from '../components/forms';
import { TRANSACTION_TYPES } from '../constants';

export default function AccountInvoice() {
  return (
    <Box>
      <Typography variant="h4" sx={{ pl: 3, pt: 2, mb: 1 }}>
        Account Invoice
      </Typography>
      <TransactionForm type={TRANSACTION_TYPES.INVOICE} />
    </Box>
  );
}